import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import { TIndividualPartner } from "../../../../stores/EventStore";

const EventPartners = () => {
  const { eventPartners } = useEventStore();

  if (!eventPartners.length) return null;

  return (
    <div className={styles.EventPartners}>
      <h4 className={styles.EventPartners_Title}>Партнёры мероприятия</h4>
      <div className={styles.EventPartners_Content}>
        {eventPartners.map((partner) => (
          <EventPartner {...partner} key={partner.id} />
        ))}
      </div>
    </div>
  );
};

const EventPartner: React.FC<TIndividualPartner> = (partner) => {
  return (
    <a
      href={partner.url.includes("http") ? partner.url : `//${partner.url}`}
      target={"_blank"}
      className={styles.EventPartners_Content_Item}
    >
      <img src={partner.image} alt={`Фото партнера ${partner.id}`} />
    </a>
  );
};

export default EventPartners;
